import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { DashboardService } from 'src/api/services/dashboard.service';
import { Dashboard,PDashboard,DashboardListItem } from 'src/api/models';
import { BehaviorSubject, Observable } from "rxjs";
import { Observable as __Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';


import { ApiConfiguration } from 'src/api/api-configuration';
import { AzureAuthService } from './azure-auth.service';

@Injectable()
export class DashboardTableService {

    public results: Dashboard[];
    public available: Dashboard[];
    public availableDashboards: DashboardListItem[];
    public remoteData: Observable<Dashboard[]>;
    private _remoteData: BehaviorSubject<Dashboard[]>;
    private http: HttpClient;
    private openService : DashboardService;

    public loading: boolean = false;
    public customerId: number;
    public searchFilter: string;

    constructor(private readonly httpHandler: HttpBackend, private readonly service: DashboardService, private toasterService: ToastrService, public azureAuthService: AzureAuthService) {
      this._remoteData = new BehaviorSubject([]);
      this.remoteData = this._remoteData.asObservable();
      this.http = new HttpClient(httpHandler);
      this.openService = new DashboardService(new ApiConfiguration(), this.http);
    }

    getDashboard(id: string, isPublic: boolean) :  Observable<Dashboard>{
      //debugger;
      if (isPublic){//document.URL.indexOf('/public/') >= 0 || document.URL.indexOf('/embed/') >= 0){
        return this.openService.DashboardGetPublicDashboardById(id);
      }
      else {
        return this.service.DashboardGetDashboard(parseInt(id));
      }
    }

    getPublication(identifier: string, isPublic: boolean) :  Observable<PDashboard>{
      if (isPublic){
        return this.openService.DashboardGetPublication(identifier);
      }
      else {
        return this.service.DashboardGetPublication(identifier);
      }
    }

    get(customerId: number) {
      this.loading = true;
      if (this.customerId == customerId && this.loading){
        // already fetching the data
        this.loading = false;
        return;
      } else {
        this.customerId = customerId;
        
        this.service.DashboardGetCustomerDashboards(customerId).subscribe(results => {
          console.log(results);
          this.loading = false;
          this.results = results;
          if (this.azureAuthService.isAdmin()){
            this._remoteData.next(results);
          }else{
            this._remoteData.next(results.filter(d => d.siteType == ''));
          }
          this.available = results.filter(d => d.published);
          this.availableDashboards = results.filter(d => d.published).map<DashboardListItem>(dd => ({ 
            dashboardId: dd.dashboardId, 
            dashboardIdentifier: dd.publishedIdentifier,
            name: dd.name, 
            public:dd.publishedToPublic, 
            index:0, 
            displaySeconds:60, 
            dashboardListItemId:0}));
        }, err => {
          this.loading = false;
          this.toasterService.error(err, "Failed to load dashboards");
        });
      }
    }

    filterCategory(category:string){
      this._remoteData.next(this.results.filter(d => d.category == category && d.siteType == ''));
    }

    filterSearch(search:string){
      this._remoteData.next(this.results.filter(d => d.name && d.siteType == '' && d.name.toLowerCase().indexOf(search.toLowerCase()) >= 0));
    }

    add(customerId: number, dashboard: Dashboard) : Observable<Dashboard> {
      return this.service.DashboardAddCustomerDashboard({customerId:customerId, dashboard: dashboard})
    }

    remove(dashboard: Dashboard) {
      this.service.DashboardRemoveDashboard(dashboard);
    }

    update(dashboard: Dashboard) : Observable<Dashboard> {
      return this.service.DashboardUpdateDashboardDetails(dashboard);
    }
    


}
